<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">ユーザー管理</div>
      </md-card-header>

      <md-card-content>
        <a href="#" @click="backToList()">
          <md-button class="md-raised">
            <md-icon>arrow_back</md-icon>
            <span>戻る</span>
          </md-button>
        </a>
      </md-card-content>

      <md-card-content v-if="fetchDetail && errorNotFound()">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages" v-if="errorMessages.length"></flash-message>
          </div>
        </div>
      </md-card-content>
      <loading-spinner v-else-if="loadingSpinner"></loading-spinner>
      <div class="md-layout" v-else-if="fetchDetail">
        <div class="md-layout-item md-size-20 md-small-size-100"></div>
        <div class="md-layout-item md-size-60 md-small-size-100">
          <flash-message :errors="errorMessages" v-if="errorMessages.length"></flash-message>
          <form @submit.prevent="submitForm" novalidate>
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-small-size-100">
                  <p class="md-caption">
                    ユーザーを追加登録した時点で月額料金に加算されます。追加登録を行う前に必ず
                    <a href="/simulation2" rel="noopener" target="_blank">料金シミュレーション</a>
                    でご確認ください。</p>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>部門</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('group_id')">
                    <label>部門</label>
                    <md-select name="groupSelected" id="groupSelected" v-model="form.group_id"
                               :disabled="sending || !isSuperUser()" required>
                      <md-option v-for="(group) in groups" v-bind:key="group.group_id"
                                 :value="group.group_id">
                        {{ optionLabel(group) }}
                      </md-option>
                    </md-select>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('group_id')">{{ getValidationResponseMessage('group_id') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.group_id.required">{{ errors.group_id.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.group_id.notUnspecified">{{ errors.group_id.required }}</span>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>権限</label>
                </div>
                <div class="md-layout-item md-small-size-100" style="margin-bottom: 20px">
                  <md-field :class="getValidationClass('role')" style="margin-bottom: 0">
                    <label>権限</label>
                    <md-select required v-model="form.role" :disabled="sending || is_account_of_current_auth">
                      <md-option v-for="(role) in roleOptions" v-bind:key="role.id" :value="role.id">
                        {{ role.label }}
                      </md-option>
                    </md-select>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('role')">{{ getValidationResponseMessage('role') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.role.required">{{ errors.role.required }}</span>
                  </md-field>
                  <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100" v-if="selectRoleSuperUser && !isSuperUserByRoleKey(roleInit) && !is_account_of_current_auth"></div>
                  <div class="md-layout-item" v-if="selectRoleSuperUser && !isSuperUserByRoleKey(roleInit) && !is_account_of_current_auth">
                    <span class="md-caption text-red">
                      ※ このユーザーに管理者権限を譲渡します。あなたの権限は「部門管理者」に変更されます。<br/>「登録する」を押して変更を完了してください。
                    </span>
                  </div>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>ユーザー名</label>
                </div>
                <div class="md-layout-item">
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-50">
                      <md-field :class="getValidationClass('name_last')">
                        <label>姓</label>
                        <md-input v-model="form.name_last" required :disabled="sending"></md-input>
                        <span class="md-helper-text">例) JON</span>
                        <span class="md-error"
                              v-if="getValidationResponseMessage('name_last')">{{ getValidationResponseMessage('name_last') }}</span>
                        <span class="md-error"
                              v-else-if="!$v.form.name_last.required">{{ errors.name_last.required }}</span>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-50">
                      <md-field :class="getValidationClass('name_first')">
                        <label>名</label>
                        <md-input v-model="form.name_first" required :disabled="sending"></md-input>
                        <span class="md-helper-text">例) 太郎</span>
                        <span class="md-error"
                              v-if="getValidationResponseMessage('name_first')">{{ getValidationResponseMessage('name_first') }}</span>
                        <span class="md-error"
                              v-else-if="!$v.form.name_first.required">{{ errors.name_first.required }}</span>
                      </md-field>
                    </div>
                  </div>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label></label>
                </div>
                <div class="md-layout-item">
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-50">
                      <md-field :class="getValidationClass('kana_last')">
                        <label>セイ</label>
                        <md-input v-model="form.kana_last" required :disabled="sending"></md-input>
                        <span class="md-helper-text">例) ジェイオーエヌ</span>
                        <span class="md-error"
                              v-if="getValidationResponseMessage('kana_last')">{{ getValidationResponseMessage('kana_last') }}</span>
                        <span class="md-error"
                              v-else-if="!$v.form.kana_last.required">{{ errors.kana_last.required }}</span>
                        <span class="md-error"
                              v-else-if="!$v.form.kana_last.katakana">{{ errors.kana_last.katakana }}</span>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-50">
                      <md-field :class="getValidationClass('kana_first')">
                        <label>メイ</label>
                        <md-input v-model="form.kana_first" required :disabled="sending"></md-input>
                        <span class="md-helper-text">例) タロウ</span>
                        <span class="md-error"
                              v-if="getValidationResponseMessage('kana_first')">{{ getValidationResponseMessage('kana_first') }}</span>
                        <span class="md-error"
                              v-else-if="!$v.form.kana_first.required">{{ errors.kana_first.required }}</span>
                        <span class="md-error"
                              v-else-if="!$v.form.kana_first.katakana">{{ errors.kana_first.katakana }}</span>
                      </md-field>
                    </div>
                  </div>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>アカウント</label>
                </div>
                <div class="md-layout-item">
                  <md-field :class="getValidationClass('username')"
                            class="md-layout-item">
                    <label>ユーザーID</label>
                    <span class="md-prefix">{{ getCorporationUid() }}-</span>
                    <md-input v-model="form.username" required :disabled="userId !== null || sending"></md-input>
                    <span class="md-helper-text">発行されるユーザーID【 {{ getUsernameResult() }} 】</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('username')">{{ getValidationResponseMessage('username') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.username.required">{{ errors.username.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.username.loginId">{{ errors.username.loginId }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.username.minLength">{{ errors.username.minLength }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.username.maxLength">{{ errors.username.maxLength }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout-item">
                  <div class="md-layout md-alignment-center-space-between">
                    <span class="md-caption">
                      例) {{ getCorporationUid() }}-jontaro、※ 半角英数字を含む6文字以上11文字以下
                    </span>
                  </div>
                </div>
              </div>

              <div class="md-layout md-gutter mt-1">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout-item">
                  <div class="md-layout md-alignment-center-space-between">
                    <md-field :class="getValidationClass('password')"
                              class="md-layout-item mb-5">
                      <label>パスワード{{ userId !== null && (form.password === null || form.password === '') ? '：（変更する場合のみ）'
                        : '' }}</label>
                      <md-input :disabled="sending" :required="userId === null" v-model="form.password"></md-input>
                      <span class="md-helper-text">※ 半角英数字をそれぞれ1種類以上含む8文字以上</span>
                      <span class="md-error"
                            v-if="getValidationResponseMessage('password')">{{ getValidationResponseMessage('password') }}</span>
                      <span class="md-error"
                            v-else-if="!$v.form.password.required">{{ errors.password.required }}</span>
                      <span class="md-error"
                            v-else-if="!$v.form.password.password">{{ errors.password.password }}</span>
                      <span class="md-error"
                            v-else-if="!$v.form.password.minLength">{{ errors.password.minLength }}</span>
                      <span class="md-error"
                            v-else-if="!$v.form.password.maxLength">{{ errors.password.maxLength }}</span>
                    </md-field>
                    <md-button @click="randomPassword" class="md-raised md-layout-item md-size-15" title="ランダムなパスワードを生成します">
                      <md-icon>refresh</md-icon>
                    </md-button>
                  </div>
                </div>
              </div>

              <div class="md-layout md-gutter mt-1 mb-2">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-size-70 md-small-size-100">
                  <md-field :class="getValidationClass('email')">
                    <label>メールアドレス</label>
                    <md-input v-model="form.email" required
                              :disabled="sending"></md-input>
                    <span class="md-helper-text">例) jontaro@jon.co.jp</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('email')">{{ getValidationResponseMessage('email') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.email.required">{{ errors.email.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.email.email">{{ errors.email.email }}</span>
                  </md-field>
                </div>
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout-item">
                  <span class="md-caption">
                    ※ こちらのメールアドレスにログインID、パスワードを送信します<br />
                    ※ 同法人内の別アカウントで登録しているメールアドレスもご利用が可能です。
                  </span>
                </div>
              </div>

              <div class="md-layout md-gutter mb-5">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>登記情報提供サービスID</label>
                </div>
                <div class="md-layout-item">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-50">
                      <div class="md-layout md-alignment-center-space-between">
                        <md-field :class="getActivationValidationClass()"
                                  class="md-layout-item mb-5">
                          <label>登記情報提供サービスID</label>
                          <md-input name="mail" v-model="form.t_service_id" required
                                    :disabled="sending"/>
                          <span class="md-helper-text">※登記情報提供サービスの利用者IDをご利用ください。管理者ID、一時利用IDはご利用いただけません。</span>
                          <span class="md-error"
                                v-if="getValidationResponseMessage('t_service_id')">{{ getValidationResponseMessage('t_service_id') }}</span>
                          <span class="md-error"
                                v-else-if="!$v.form.t_service_id.required">{{ errors.t_service_id.required }}</span>
                          <span class="md-error"
                                v-else-if="!$v.form.activated.required">{{ unactivatedMessage }}</span>
                        </md-field>
                      </div>
                    </div>
                    <div class="md-layout-item md-size-50 mt-2">
                      <div class="md-layout md-alignment-center-space-between">
                        <md-icon v-if="form.activated" class="md-checkbox-checked">check_box</md-icon>
                        <md-icon v-else>check_box_outline_blank</md-icon>
                        <md-button @click="openDialog" class="md-raised md-primary md-layout-item md-size-70" :disabled="sending || (form.activated && !this.$props.id)">
                          <span>パスワード入力</span>
                        </md-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </md-card-content>

            <md-card-actions>
              <div class="md-layout md-alignment-center">
                <md-button :disabled="sending" class="md-primary md-raised" type="submit">
                  <md-icon>save</md-icon>
                  <span>登録する</span>
                </md-button>
              </div>
            </md-card-actions>
          </form>
        </div>
      </div>
    </md-card>

    <activation-modal :md-active.sync="showDialog" v-bind:t_service_id="form.t_service_id"
                      @close="closeActivationModal" @activationSuccess="activationSuccess"></activation-modal>
    <confirm-account-registration-modal
      :md-active.sync="confirmRegister"
      :email="form.email"
      :password="form.password"
      :display="confirmRegister"
      @md-cancel="onCancelRegister"
      @md-confirm="onConfirmRegister"
      md-content="ユーザーを追加登録した時点で月額料金に加算されます。<br/>追加登録を行う前に必ず<a href='/simulation2' rel='noopener' target='_blank'>料金シミュレーション</a>でご確認ください。"
      md-title="ユーザー登録の確認"/>
  </main>
</template>

<script>
  import FlashMessage                                         from '../../../components/FlashMessage';
  import Common                                               from '../../../modules/common';
  import LoadingSpinner                                       from '../../../components/LoadingSpinner';
  import Password                                             from '../../../modules/password';
  import CommonMixin                                          from '../../../mixins/commonMixin';
  import {apiClientWithUserToken as apiClient, apiList}       from '../../../modules/apiClient';
  import {validationMixin}                                    from 'vuelidate'
  import {email, maxLength, minLength, required, requiredIf,} from 'vuelidate/lib/validators'
  import Validation                                           from '../../../modules/validation';
  import LoadingSpinnerOverlay                                from '../../../components/LoadingSpinnerOverlay';
  import ActivationModal                                      from '../../../components/ActivationModal';
  import ConfirmModal                                         from '../../../components/ConfirmModal';
  import {mapActions}                                         from 'vuex';
  import ConfirmAccountRegistrationModal                      from '../../../components/ConfirmAccountRegistrationModal';

  /** Validate groupId */
  const notUnspecified = (value) => value !== 'null';

  export default {
    name      : "UserNew",
    mixins    : [CommonMixin, validationMixin],
    props     : {
      id: String,
    },
    components: {
      ConfirmAccountRegistrationModal,
      LoadingSpinnerOverlay,
      FlashMessage,
      LoadingSpinner,
      ActivationModal,
      ConfirmModal,
    },
    data      : () => ({
      userId                    : null,
      auth_role_key             : null,
      is_account_of_current_auth: false,
      roleInit                  : null,
      form                      : {
        group_id    : null,
        role        : null,
        name_last   : null,
        name_first  : null,
        kana_last   : null,
        kana_first  : null,
        username    : null,
        password    : null,
        email       : null,
        t_service_id: null,
        activated   : null,
        uid         : null,
      },
      showDialog        : false,
      confirmRegister   : false,
      errors            : {
        group_id    : {
          required: Validation.errorMessage(Validation.rules.required, 'groupName'),
        },
        role        : {
          required: Validation.errorMessage(Validation.rules.required, 'role'),
        },
        name_last   : {
          required: Validation.errorMessage(Validation.rules.required, 'firstName'),
        },
        name_first  : {
          required: Validation.errorMessage(Validation.rules.required, 'lastName'),
        },
        kana_last   : {
          required: Validation.errorMessage(Validation.rules.required, 'lastKana'),
          katakana: Validation.errorMessage(Validation.rules.katakana, 'lastKana'),
        },
        kana_first  : {
          required: Validation.errorMessage(Validation.rules.required, 'firstKana'),
          katakana: Validation.errorMessage(Validation.rules.katakana, 'firstKana'),
        },
        username    : {
          required : Validation.errorMessage(Validation.rules.required, 'userId'),
          minLength: Validation.errorMessage(Validation.rules.minLength, 'userId', 6),
          maxLength: Validation.errorMessage(Validation.rules.maxLength, 'userId', 11),
          loginId  : Validation.errorMessage(Validation.rules.loginId, 'userId'),
        },
        password    : {
          required : Validation.errorMessage(Validation.rules.required, 'password'),
          minLength: Validation.errorMessage(Validation.rules.minLength, 'password', 8),
          maxLength: Validation.errorMessage(Validation.rules.maxLength, 'password', 100),
          password : Validation.errorMessage(Validation.rules.password, 'password'),
        },
        email       : {
          required: Validation.errorMessage(Validation.rules.required, 'email'),
          email   : Validation.errorMessage(Validation.rules.email, 'email'),
        },
        t_service_id: {
          required: Validation.errorMessage(Validation.rules.required, 'tServiceID'),
        },
      },
      roles              : [],
      selectRoleSuperUser: false,
      groups             : [],
      oldTServiceId      : null,
      unactivatedMessage : Common.messages.activation.unactivated,
      authAccount        : null,
    }),
    validations() {
      return {
        form: {
          group_id    : {
            required,
            notUnspecified,
          },
          role        : {
            required,
          },
          name_last   : {
            required,
          },
          name_first  : {
            required,
          },
          kana_last   : {
            required,
            katakana: Validation.katakana,
          },
          kana_first  : {
            required,
            katakana: Validation.katakana,
          },
          username    : {
            required,
            minLength: minLength(6),
            maxLength: maxLength(11),
            loginId  : Validation.loginId,
          },
          password    : {
            required : requiredIf(function () {
              return !this.$props.id;
            }),
            minLength: minLength(this.form.password ? 8 : 0),
            maxLength: maxLength(100),
            password : Validation.password,
          },
          email       : {
            required,
            email,
          },
          t_service_id: {
            required,
          },
          activated   : {
            required,
          },
        },
      };
    },
    mounted() {
      this.loadingSpinner = true;
      this.getAuthAccount();
      this.getGroupList();
      this.getRoleList();
    },
    updated() {
      let selectorInvalid = this.$el.querySelector(".md-invalid");
      if (selectorInvalid !== null) {
        this.scrollToSelector(selectorInvalid);
      }
      let selectorFlashError = this.$el.querySelector(".flash-error-message");
      if (selectorFlashError !== null) {
        this.scrollToSelector(selectorFlashError);
      }
    },
    computed  : {
      roleOptions: function () {
        if (this.is_account_of_current_auth) {
          return this.roles.filter(r => {
            return r.name === this.auth_role_key;
          })
        }

        if (this.isSuperUserByRoleKey(this.auth_role_key)) {
          return this.roles;
        }

        if (this.isGroupUserByRoleKey(this.auth_role_key)) {
          return this.roles.filter(r => {
            return r.name !== Common.superUserKey;
          })
        }

        if (this.isNormalUserByRoleKey(this.auth_role_key)) {
          return this.roles.filter(r => {
            return r.name !== Common.superUserKey && r.name !== Common.groupAdminKey;
          })
        }

        return [];
      },
    },
    methods   : {
      ...mapActions('users', [
        'saveBack',
      ]),
      backToList() {
        this.saveBack(true);
        this.$router.replace({name: 'BackendUsers'}).then();
      },
      isEdit() {
        return this.$props.id !== null && this.$props.id !== undefined;
      },
      isSuperUserByRoleKey(roleKey) {
        return roleKey === Common.superUserKey;
      },
      isGroupUserByRoleKey(roleKey) {
        return roleKey === Common.groupAdminKey;
      },
      isNormalUserByRoleKey(roleKey) {
        return roleKey === Common.normalUserKey;
      },
      /**
       * Get error not found data
       */
      errorNotFound() {
        if (this.$props.id) {
          if (!this.userId) {
            this.errorMessages = [Common.messages.account.notFound];
            return true;
          }
        }
        return false;
      },
      /**
       * option label groups
       */
      optionLabel(group) {
        if (group.level === 0) {
          return group.name;
        }
        return new Array(group.level + 1).join('　') + group.name;
      },
      /**
       * Parse user detail
       */
      parseUserDetail(account) {
        if (account === null) {
          this.userId = null;
          return;
        }

        if (account.id === this.authAccount.id) {
          this.is_account_of_current_auth = true;
        }

        this.form = {
          group_id    : account.group.id,
          role        : account.role ? account.role : null,
          name_last   : account.name_last,
          name_first  : account.name_first,
          kana_last   : account.kana_last,
          kana_first  : account.kana_first,
          username    : account.username,
          email       : account.email,
          t_service_id: account.t_service_id,
          password    : null,
          activated   : null
        };
        if (account.t_service_id) {
          this.form.activated = true;
          this.oldTServiceId  = account.t_service_id;
        } else {
          this.errorMessages = [Common.messages.activation.reActivated];
        }
        if (account.username && account.corporation && account.corporation.uid) {
          this.form.uid = account.corporation.uid;
          const prefix  = this.form.uid + '-';
          if (account.username.startsWith(prefix)) {
            this.form.username = account.username.slice(prefix.length);
          }
        }
      },
      /**
       * Get auth account
       */
      getAuthAccount() {
        this.authAccount   = Common.getCurrentUserInfo();
        this.auth_role_key = this.authAccount.roles[0] ? this.authAccount.roles[0] : null;
      },
      /**
       * Get list of groups
       */
      getGroupList() {
        apiClient.get(apiList.jon.groups.list)
          .then(response => {
            this.groups = this.parsedGroups(response.data.data, 0);
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            if (this.groups.length > 0 && !this.$props.id) {
              this.form.group_id = this.groups[0].group_id;
            }
            if (this.isGroupAdmin()) {
              this.form.group_id = this.authAccount.group.id;
            }
            this.loadingSpinner = false;
          });
      },
      /**
       * Set role init
       */
      setRoleInit(roles) {
        for (let key in roles) {
          if (roles[key].name === Common.normalUserKey) {
            this.form.role = roles[key].id;
            this.roleInit  = this.form.role;
          }
        }
      },
      /**
       * Get list of roles
       */
      getRoleList() {
        apiClient.get(apiList.accounts.roles)
          .then(response => {
            this.roles = this.parseRoles(response.data.data);
            this.setRoleInit(this.roles);
            this.getUserDetail();
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.loadingSpinner = false;
          });
      },
      parseRoles(roles) {
        roles.sort((a, b) => Common.roleOrdered.indexOf(a.name) - Common.roleOrdered.indexOf(b.name))
        if (this.isSuperUser()) {
          return roles;
        }
        return roles.filter(role => role.id !== Common.roleSuperUser);
      },
      /**
       * Get user detail
       */
      getUserDetail() {
        if (!this.$props.id) {
          this.fetchDetail    = true;
          this.loadingSpinner = false;
          return;
        }
        this.userId = this.$props.id;

        apiClient.get(apiList.accounts.detail.replace(':account_id', this.userId))
          .then(response => {
            if (this.hasResponseErrors(response)) {
              this.userId        = null
              this.errorMessages = [Common.messages.account.notFound];
              return;
            }
            this.parseUserDetail(response.data);
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.loadingSpinner = false;
            this.fetchDetail    = true;
          });
      },
      createFormData(sendPassword = null) {
        const username = this.$props.id ? (this.form.uid + '-' + this.form.username) : this.form.username;
        let formData   = {
          group_id    : this.form.group_id,
          role        : this.form.role,
          name_last   : this.form.name_last,
          name_first  : this.form.name_first,
          kana_last   : this.form.kana_last,
          kana_first  : this.form.kana_first,
          username    : username,
          password    : this.form.password,
          email       : this.form.email,
          t_service_id: this.form.t_service_id,
        };

        if (sendPassword !== null) {
          formData = Object.assign(formData, {send_password: sendPassword})
        }

        // 更新時、パスワードが更新対象でなければ送信対象としないようにする
        if (this.$props.id && this.form.password === null) {
          delete formData['password'];
        }

        return formData;
      },
      /**
       * Update user account
       */
      updateUser(sendPassword) {
        this.sending          = true;
        this.validateResponse = [];
        const url             = apiList.accounts.update.replace(':account_id', this.userId);
        apiClient.put(url, this.createFormData(sendPassword))
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            if (this.isTransferSuperAdminRole()) {
              this.forceLogOut();
              return;
            }
            this.setSnackBar(Common.messages.account.updateSuccess);
            this.backToList();
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending         = false;
            this.confirmRegister = false;
            this.$v.$reset();
            if (this.getValidationResponseMessage('t_service_id')) {
              this.oldTServiceId  = null;
              this.form.activated = null;
            }
          });
      },
      /**
       * Registry user account
       */
      registerUser(sendPassword) {
        this.sending          = true;
        this.validateResponse = [];
        apiClient.post(apiList.accounts.registration, this.createFormData(sendPassword))
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            if (this.isTransferSuperAdminRole()) {
              this.forceLogOut();
              return;
            }
            this.setSnackBar(Common.messages.account.registrySuccess);
            this.backToList();
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending         = false;
            this.confirmRegister = false;
            this.$v.$reset();
            if (this.getValidationResponseMessage('t_service_id')) {
              this.oldTServiceId  = null;
              this.form.activated = null;
            }
          });
      },
      onConfirmRegister(sendPassword) {
        if (this.$props.id) {
          this.updateUser(sendPassword);
        } else {
          this.registerUser(sendPassword);
        }
      },
      onCancelRegister() {
        this.confirmRegister = false;
      },
      /**
       * Submit form
       */
      submitForm() {
        this.$v.form.group_id.$touch();
        this.$v.form.role.$touch();
        this.$v.form.name_last.$touch();
        this.$v.form.name_first.$touch();
        this.$v.form.kana_last.$touch();
        this.$v.form.kana_first.$touch();
        this.$v.form.username.$touch();
        this.$v.form.password.$touch();
        this.$v.form.email.$touch();
        this.$v.form.t_service_id.$touch();
        this.$v.form.activated.$touch();
        if (!this.$v.form.$invalid) {
          if (this.$props.id && (this.form.password === null || this.form.password.length === 0)) {
            this.updateUser(false);
          } else {
            this.confirmRegister = true;
          }
        } else {
          if (this.$v.form.t_service_id.$invalid) {
            this.form.activated = null;
          }
          let selectorInvalid = this.$el.querySelector(".md-invalid");
          if (selectorInvalid !== null) {
            this.scrollToSelector(selectorInvalid);
          }
        }
      },
      /**
       * Random password
       */
      randomPassword() {
        this.form.password = Password.generate(8, /^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,100}$/i);
      },
      openDialog() {
        this.$v.form.t_service_id.$touch();
        if (this.$v.form.t_service_id.$invalid) {
          return;
        }
        this.showDialog = true;
      },
      closeActivationModal() {
        this.showDialog = false;
      },
      activationSuccess() {
        this.showDialog     = false;
        this.oldTServiceId  = this.form.t_service_id;
        this.form.activated = true;
      },
      getActivationValidationClass() {
        const tServiceValidation = this.getValidationClass('t_service_id');
        if (tServiceValidation["md-invalid"]) {
          return tServiceValidation;
        }
        return this.getValidationClass('activated');
      },
      getCorporationUid() {
        if (this.authAccount === null) {
          return null;
        }
        if (!this.authAccount.corporation) {
          return null;
        }
        return this.authAccount.corporation.uid;
      },
      getUsernameResult() {
        const uid = this.getCorporationUid();
        if (!uid) {
          return this.form.username;
        }
        if (!this.form.username) {
          return uid + '-';
        }
        return uid + '-' + this.form.username;
      },
      isTransferSuperAdminRole() {
        // If update yourself, no need to log out
        if (this.isEdit() && this.is_account_of_current_auth) {
          return false;
        }
        // If you do not transfer your super admin role, no need to log out
        const role = this.roles.find(role => role.id === this.form.role);
        return role.name === Common.superUserKey;
      },
      forceLogOut() {
        // Force logout when you transfer your super admin role
        localStorage.setItem(Common.localStorageKeys.user.errorTransferRole, Common.messages.errorTransferRole);
        this.logOutUser()
      },
    },
    watch     : {
      "form.t_service_id": function (newValue, oldValue) {
        if (!this.oldTServiceId) {
          return;
        }
        if (newValue === this.oldTServiceId) {
          this.form.activated = true;
        } else {
          this.form.activated = null;
        }
      },
      "form.role": function (newValue, oldValue) {
        if (newValue == Common.roleSuperUser) {
          this.selectRoleSuperUser = true;
        } else {
          this.selectRoleSuperUser = false;
        }
      }
    },
  }
</script>

<style scoped lang="scss">

  .md-dialog {
    max-width: 500px;
  }

  .md-checked {
    color: #ff5252 !important;
  }

  .md-checkbox-checked {
    color: #44D644 !important;
  }

  .mt-1 {
    margin-top: 1em;
  }

  .mb-2 {
    margin-bottom: 2em;
  }
</style>
